import Icon from "../Icon";
import {concatenate} from "../../services/string";
import React from "react";

// Types ----

type EmailVerificationStatusProps = {
  email: string;
  isVerified: boolean;
}

// Component ----

export default function EmailVerificationStatus({email, isVerified}: EmailVerificationStatusProps) {
  return (
    <div className="flex items-center">
      <Icon
        name={isVerified ? 'shield-check' : 'shield-exclamation'}
        className={concatenate(
          "h-5 w-5 mr-1",
          isVerified ? "text-gray-300" : "text-orange-400"
        )}
      />
      {' '}
      {email}
    </div>
  )
}